<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G H Raisoni Memorial All IndiaFide Rated Rapid Chess Tournament
                        Ambikapur 2026 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G H Raisoni Memorial All IndiaFide Rated Rapid Chess Tournament
                    Ambikapur 2026 </span></h2>
        </div>
        <p><strong> Date: </strong>30/05/2026 and 31/05/2026</p>
        <p><strong> Venue: </strong>Saraswati Shishu Mandir School Ambikapur</p>
        <p><strong> Organized By: </strong>Shatranj Sangh Surguja</p>
        <p><strong> In Association With: </strong>G H Raisoni Sports and Cultural Foundation and Kalpana Prakash Welfare
            Foundation</p>
        <p><strong> Under The Aegis of: </strong>All India Chess Fedretion (AICF) & Chattisgarh Pradesh Shatranj Sangh
            (CGSCA)</p>

        <h5 class="primary-purple">Introduction:</h5>
        <p> The G H Raisoni Memorial All IndiaFide Rated Rapid Chess Tournament
            Ambikapur2026, organized by Shatranj Sangh Surguja Under the agies of
            Chhattisgarh Pradesh Shatranj Sangh in association with Kalpana Prakash Welfare
            Foundation & G. H. Raisoni University, was a grand success.
        </p>
        <p>
            The event witnessed enthusiastic participation with 190 registered players
            representing 5 different State of India.The total prize fund was ₹51000, with the
            winner receiving ₹11,000.</p>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tour-report-gh-raisoni-rapid-rated-ambikapur.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
